import { Banner, ContentNode as ContentNodeType, License } from '@shapeable/types';

const formatLicenseMarkdown = (license?: License) => {
  const licenseName = license?.name?.trim();
  const licenseUrl = license?.url?.trim();

  if (!licenseName) {
    return '';
  }

  if (licenseUrl) {
    return ` — [${licenseName}](${licenseUrl})`;
  }

  return ` — ${licenseName}`;
};

/** Photo credit body for ContentNode / markdown (description links + optional license). */
export const buildTopicBannerPhotoCredit = (
  banner: Banner | undefined,
  photoLabel: string,
): ContentNodeType | null => {
  const licenseSuffix = formatLicenseMarkdown(banner?.license);
  const description = banner?.description;

  if (typeof description === 'object' && description !== null && description.text?.trim()) {
    return {
      ...description,
      text: `${photoLabel}: <i>${description.text.trim()}</i>${licenseSuffix}`,
    };
  }

  const fallbackCaption = banner?.name?.trim() || '';

  if (!fallbackCaption && !licenseSuffix) {
    return null;
  }

  const body = fallbackCaption
    ? `${photoLabel}: <i>${fallbackCaption}</i>${licenseSuffix}`
    : `${photoLabel}:${licenseSuffix.replace(/^ — /, ' ')}`;

  return { text: body };
};
